import IcChevronDownSmallRegular from '@kep/kcds-icons/IcChevronDownSmallRegular';
import IcChevronRightSmallRegular from '@kep/kcds-icons/IcChevronRightSmallRegular';

import type { SVGProps } from 'react';

export const ListToggleIcon = ({ open }: { open?: boolean }) => {
  return open ? <IcChevronDownSmallRegular /> : <IcChevronRightSmallRegular />;
};

export const EllipsisIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12" cy="12" r="3" fill="currentColor" />
    </svg>
  );
};
